import React from 'react'

const Dashboard9 = () => {
  return (
    <h1>Dashboard9</h1>
  )
}

export default Dashboard9